export default __webpack_public_path__ + "static/media/students.ae362cbf.jpg";